import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import SITE2SCOPE_LOGO from './site2scopeLogo';
import HIGGINS_LOGO from './higginsLogo';

// Role display helpers
const ROLE_LABEL = {
  bdm:       { label: 'BDM',               color: '#5B2D82', bg: '#f3e8ff' },
  estimator: { label: 'Estimator',          color: '#0369a1', bg: '#e0f2fe' },
  pm:        { label: 'Project Manager',    color: '#065f46', bg: '#d1fae5' },
  admin:     { label: 'Admin',              color: '#92400e', bg: '#fef3c7' },
};

export default function LoginScreen() {
  const { user, profile, signIn, signOut } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleSignIn = async () => {
    setBusy(true);
    setError('');
    try {
      await signIn();
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') {
        setError('Sign-in failed — please try again.');
      }
    } finally {
      setBusy(false);
    }
  };

  const role = profile?.role ? ROLE_LABEL[profile.role] : null;

  return (
    <div className="ls-screen">
      <div className="ls-card">

        {/* ── Branding ── */}
        <div className="ls-logos">
          <img src={SITE2SCOPE_LOGO} alt="Site2Scope" className="ls-s2s-logo" />
        </div>
        <div className="ls-higgins-row">
          <img src={HIGGINS_LOGO} alt="Higgins Painting" className="ls-higgins-logo" />
        </div>

        {/* ── Not signed in ── */}
        {!user && (
          <>
            <p className="ls-tagline">Field measurement &amp; scope management</p>
            <button
              className="ls-google-btn"
              onClick={handleSignIn}
              disabled={busy}
            >
              {busy ? (
                <span className="ls-btn-inner">Signing in…</span>
              ) : (
                <span className="ls-btn-inner">
                  <GoogleIcon />
                  Sign in with Google
                </span>
              )}
            </button>
            {error && <p className="ls-error">{error}</p>}
            <p className="ls-hint">Use your assigned Higgins Google account.</p>
          </>
        )}

        {/* ── Signed in but awaiting approval ── */}
        {user && !profile?.approved && (
          <>
            <div className="ls-pending-avatar">
              {(user.displayName || user.email || '?')[0].toUpperCase()}
            </div>
            <div className="ls-pending-name">{user.displayName || user.email}</div>
            {role && (
              <span className="ls-role-badge" style={{ color: role.color, background: role.bg }}>
                {role.label}
              </span>
            )}
            <div className="ls-pending-box">
              <div className="ls-pending-title"><span className="spinner spinner-sm" style={{marginRight:6}}></span> Awaiting approval</div>
              <div className="ls-pending-msg">
                Your account is pending approval from an admin. Once approved you'll be able to sign in automatically.
              </div>
            </div>
            <button className="ls-signout-btn" onClick={signOut}>
              Sign out
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg className="ls-google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
    </svg>
  );
}
